import styled, { css } from 'styled-components';

export const Banner = styled.div`
  ${({ theme, hasTrial }) => css`
    align-items: center;
    background: ${theme.v2.colors.gradient.secondary};
    border-radius: 16px;
    color: ${theme.v2.colors.white.primary};
    display: flex;
    flex-direction: column;
    gap: ${hasTrial ? '8px' : '16px'};
    padding: 32px 24px;
    text-align: center;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      border-radius: 0;
      padding: 56px 24px;
    }
  `}
`;

export const WrapperTitleStudio = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    gap: 4px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      padding-bottom: 8px;
    }
  `}
`;

export const TitleStudio = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold};
  `}
`;

export const Title = styled.div`
  ${({ theme, hasTrial }) => css`
    font-size: ${hasTrial ? theme.v2.font.sizes.md : theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.medium};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xs};
    }
  `}
`;

export const Subtitle = styled.div`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
  `}
`;
